import axios from 'axios';
import environment, { EnvironmentVariables } from './utils/environment';
import { isMobile } from './utils/utils';

const BASE_URL = environment.get(
  EnvironmentVariables.BASE_URL,
  'https://test2.viome.com',
);
const AUTH_URL = environment.get(
  EnvironmentVariables.AUTH_URL,
  'https://testauth.viome.com',
);

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  withCredentials: !isMobile,
});

export const authAxiosInstance = axios.create({
  baseURL: AUTH_URL,
  timeout: 30000,
  withCredentials: !isMobile,
});
